module.exports = __webpack_public_path__ + "static/media/item_22_1_comp.9df34b85.png";